import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { createValidateSearch } from '@authy/lib-web/routes'

import { rootRoute } from '@/tenant/userManagement/root'

import { SearchSchema, listUsers } from './routeUtils'

const validateSearch = createValidateSearch(SearchSchema)

export const listRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/list',
    component: lazyRouteComponent(() => import('./List'), 'List'),
    validateSearch,
    loaderDeps: ({ search }) => search,
    loader: async ({ abortController, deps, parentMatchPromise }) => {
        await parentMatchPromise
        return await listUsers(deps, 0, abortController)
    },
})
